module.exports = __webpack_public_path__ + "img/喷油咀.png";